import React, { type FC, useCallback } from "react";
import { type AppDispatch, type RootState } from "../../../../../../../Application/globaltypes/redux";

import { connect, type ConnectedProps } from "react-redux";
import { bindActionCreators } from "redux";
import * as backgroundTasksActionsRedux from "../../../../../../../BackgroundTasks/state/backgroundTasksActions";
import UsersFileUploadModal from "../../../../../../../../components/usersFileUploadModal/UsersFileUploadModal";
import typedDataService from "../../../../../../../Application/services/dataServices/typedDataService";
import { bindAction } from "../../../../../../../../interfaces";
import { showGeneralLoaderWithTimeout } from "../../../../../../../Application/actions/generalLoader/generalLoaderActions";
import * as usersOverviewActionsRedux from "../../../../../../Users/UsersOverview/state/usersOverviewActions";
import { reset } from "../../../../../../../Licensing/ContentAssignmentModalLicensingSteps/state/slices/licensingModalSlice";
import { setActiveModal } from "../../../../state/slices/groupMembersModalsSlice";

export interface Props extends PropsFromRedux {
  groupId: number;
  showModal: boolean;
  uploadedFile: File | null;
  setUploadedFile: (file: File | null) => void;
}
export const UsersFileUploadModalContainer: FC<Props> = (props) => {
  const onFileDisposed = useCallback(() => props.setUploadedFile(null), [props]);

  const startUsersImportHandler = (fileName: string, mappedFields: { [key: string]: any }) => {
    return typedDataService.users.startUsersImportForGroup(fileName, props.groupId, mappedFields);
  };

  const onCloseAddUsersModalHandler = () => {
    props.resetLicensingModalAction();
    props.setActiveModalAction(null);
  };

  return (
    <UsersFileUploadModal
      showModal={props.showModal}
      groupId={props.groupId}
      modalTitle="Add Members via CSV"
      startUsersImport={startUsersImportHandler}
      showGeneralLoaderWithTimeout={props.showGeneralLoaderWithTimeout}
      addBackgroundTask={props.backgroundTasksActions.addTask}
      removeBackgroundTask={props.backgroundTasksActions.deleteTask}
      cancelBackgroundTask={props.backgroundTasksActions.cancelTask}
      accountId={props.accountId}
      actorId={props.actorId}
      showLicenceStep={props.showLicenceStep}
      onClose={onCloseAddUsersModalHandler}
      isFileUploading={props.usersFileUploadStatus.isUploading}
      droppedFile={props.uploadedFile}
      onFileDisposed={onFileDisposed}
      uploadProgress={props.usersFileUploadStatus.progress}
      uploadError={props.usersFileUploadStatus.error}
      uploadUsersFile={props.usersOverviewActions.uploadUsersFile}
      getUploadedFileColumns={props.usersOverviewActions.fetchUploadedFileColumns}
      getUsersImportPreviewData={props.usersOverviewActions.fetchUsersImportPreviewData}
      uploadedUsersFileColumns={props.uploadedUsersFileColumns}
      cancelUsersFileUpload={props.usersOverviewActions.cancelUsersFileUpload}
      resetUsersFileUpload={props.usersOverviewActions.resetUsersFileUpload}
      updateUsersFileUploadProgress={props.usersOverviewActions.updateUsersFileUploadProgress}
      usersImportPreviewData={props.usersImportPreviewData}
      resetUsersImportPreviewData={props.usersOverviewActions.resetUsersImportPreviewData}
      backgroundTasks={props.backgroundTasks}
    />
  );
};

/* istanbul ignore next */
const mapStateToProps = (state: RootState) => ({
  showLicenceStep: state.people.addGroup.groupMembers.modalOptions.showLicenceStep,
  usersFileUploadStatus: state.people.usersOverview.usersFileUploadStatus,
  uploadedUsersFileColumns: state.people.usersOverview.uploadedFileColumns,
  usersImportPreviewData: state.people.usersOverview.usersImportPreviewData,
  backgroundTasks: state.backgroundTasks.tasks,
  accountId: state.userProfile.accountId,
  actorId: state.userProfile.id,
});

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: AppDispatch) => ({
  usersOverviewActions: bindActionCreators(usersOverviewActionsRedux, dispatch),
  backgroundTasksActions: bindActionCreators(backgroundTasksActionsRedux, dispatch),
  showGeneralLoaderWithTimeout: bindAction(showGeneralLoaderWithTimeout, dispatch),
  resetLicensingModalAction: bindAction(reset, dispatch),
  setActiveModalAction: bindAction(setActiveModal, dispatch),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const ConnectedComponent = connector(UsersFileUploadModalContainer);
export default ConnectedComponent;
